import { useDispatch } from 'react-redux'
import { Input } from 'components/Input/Input'
import { updateEntry } from 'apps/builder/store/actions/entries'

import {
  MinMaxRange,
  NumberFieldStyleOptions,
  RequiredToggle,
  ReadOnlyToggle,
  DecimalToggle,
  SettingsFieldSelect,
} from 'apps/builder/components/settings/modal/shared'

import {
  useDefaultValueNumberValidation,
  useDefaultValueDecimalValidation,
} from 'apps/builder/lib/hooks/smartPreviewValidationHook'

export const NumberField = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue = '',
  style = style || 0,
  minimum,
  maximum,
  type,
  mask,
  keyField,
}) => {
  const dispatch = useDispatch()

  const isDecimalAllowed = `${mask}` !== '0'
  const [isValid, errorText] = isDecimalAllowed
    ? useDefaultValueDecimalValidation({
        minimum,
        maximum,
        value: defaultValue,
        mask,
      })
    : useDefaultValueNumberValidation({
        minimum,
        maximum,
        value: defaultValue,
      })
  
  const changeFieldType = ({
    id,
    original_type_id,
    placeholder: newPlaceholder,
    ...type
  }) => {
    dispatch(
      updateEntry({
        ...type,
        entry_type_id: id,
        original_type_id: original_type_id,
        guid,
        label: label,
        placeholder: newPlaceholder,
      })
    )
    //clears default value if validates as false/wrong format when switching field type
    isValid ? updateDefaultValue(defaultValue) : updateDefaultValue('')
  }

  const updateDefaultValue = value => {
    dispatch(
      updateEntry({
        guid,
        default: value,
      })
    )
  }

  /** if the user switches from allow decimal to not allow decimal and the default val
   * contains a decimal, kick it out
   */
  if (defaultValue && defaultValue.includes('.') && `${mask}` === '0') {
    const newValue = defaultValue.split('.')[0]
    updateDefaultValue(newValue)
  }

  const change = input => {
    updateDefaultValue(input)
  }

  const inputProps = {
    id: `default-${guid}`,
    value: defaultValue,
    placeholder: ' ',
    errorText: errorText,
    error: !isValid,
    update: change,
    label: 'Default Value',
  }

  const onSaveFormat = style => {
    const format = {
      0: 'Number',
      4: 'Currency',
      1: 'Increment',
      2: 'Slider',
    }
    return format[style]
  }

  const numberStyle = onSaveFormat(style)

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
          onChange={changeFieldType}
        />
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
          <div className="toggle-wrapper">
            <ReadOnlyToggle guid={guid} active={read_only} />
          </div>
        </div>
      </div>
      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <NumberFieldStyleOptions
          guid={guid}
          selected={numberStyle}
          default={defaultValue}
          keyField={keyField}
        />
      </div>
      <MinMaxRange
        guid={guid}
        type={type}
        minimum={minimum}
        maximum={maximum}
      />
      <div className="settings--default-value">
        <Input {...inputProps} />
      </div>
    </>
  )
}
